import { useUIStore } from "@/stores/useUIStore";

const LOCALE_MAP: Record<string, string> = {
  en: "en-US",
  es: "es-ES",
  pt: "pt-BR",
};

/**
 * Returns an Intl-compatible locale string based on the current language.
 * Use this when calling formatTokenAmount, formatDate, formatRelativeTime, etc.
 */
export function useLocale(): string {
  const language = useUIStore((s) => s.language);
  return LOCALE_MAP[language] ?? "en-US";
}
